import { msg } from 'gt-react';
import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Action, Subject } from '@erp/authz';
import { Route as parent, requirePermission } from '../../route';
import { ReportPage } from './ReportPage';

/**
 * `/reports/$appId` — a Report App: read-only and filterable, read as the
 * viewer, so it needs Workbook access rather than Apps access. `inputs`
 * carries the filters, so a link opens the Report as it was shared.
 */
export const Route = createRoute({
  getParentRoute: () => parent,
  path: '/reports/$appId',
  component: ReportPage,
  validateSearch: z.object({
    inputs: z.record(z.string(), z.unknown()).optional(),
  }),
  loader: () => ({
    crumb: msg('Report', { context: 'page breadcrumb for a Report App' }),
  }),
  beforeLoad: async ({ context }) =>
    requirePermission({
      context,
      action: Action.Read,
      subject: Subject.Workbook,
    }),
});
